export type UpdateInterfaceDeploymentRequestRequest = {
  dfnSetVerNum: string;
  dplymntReqSeq: string;
  dplyImplType: string;
  forceStgDplyFlg: boolean;
  dplymntDtime?: string;
  updateDtimeTDplymntReqMng: string;
  ifList: Interface[];
};

type Interface = {
  interfaceRequirementId: string;
  updateDTimeTIfReq: string;
  srcDstType: string;
  tcktId: string;
  pendingFlag?: boolean;
};
